<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!is_data_available">
    <div class="col">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
      </mat-progress-spinner>
    </div>
  </div>
  <span *ngIf="is_data_available">
    <mat-card *ngFor="let order of by_product_order_list; let order_index=index" style="margin-bottom: 2%">
      <div class="row">
        <div class="col"><label>{{order['business_code']}} - {{order['agent_name']}}</label></div>
        <div class="col" *ngIf="order['is_for'] == 'Employee' || order['business_type_id'] == 14">
          <mat-chip style="background: antiquewhite;padding: 10px;border-radius: 14px;">Employee Order
          </mat-chip>
        </div>
        <div class="col"><label>Ordered On : {{order['ordered_date'] | date}} Via
            {{order['ordered_via']}}</label></div>
        <div class="col-2"><label>Total Price : {{order['total_cost'] | currency: 'INR'}}</label></div>
        <div class="col-3" *ngIf="order['sale_status_id'] == 1">
          <button mat-button (click)="gatePassCalled(order, order_index)" onclick="this.disabled=true"
            style="background: #64073d;border-radius: 10px; font-size: 23px; color: white;">Prepare
            Gatepass</button>
        </div>
        <div class="col-3" *ngIf="order['is_for'] == 'Employee' && order['sale_status_id'] == 2">
          <button mat-button (click)="downloadGatePass(order, 'dc')"
            style="background: green;border-radius: 10px; font-size: 23px; color: white; margin-left: 12%;">Temp
            Dc</button>
        </div>
        <div class="col-3" *ngIf="order['is_for'] != 'Employee' && order['sale_status_id'] == 2">
          <button mat-button (click)="downloadGatePass(order, 'bill')"
            style="background: green;border-radius: 10px; font-size: 23px; color: white;">Bill</button>
          <button mat-button (click)="downloadGatePass(order, 'dc')" *ngIf="order['business_type_id'] !== 14"
            style="background: green;border-radius: 10px; font-size: 23px; color: white; margin-left: 12%;">Dc</button>
        </div>
        <div class="col-1"
          *ngIf="order['is_for'] != 'Employee' && order['sale_status_id'] == 2 && order['ordered_date'] == today_date">
          <i style="cursor: pointer;" class="material-icons"
            (click)="deleteSaleClicked(order['by_sale_group_id'])">delete</i>
        </div>
      </div><br>
      <div class="row">
        <div class="col" style="text-align: right;" *ngIf="order_index != selected_index">
          <button mat-button (click)="showProductClicked(order_index)" style="background: #dfb59b;">Show Product &nbsp;
            <i class="material-icons" style="font-size: 25px;">
              expand_more
            </i>
          </button>
        </div>
        <div class="col" style="text-align: right;" *ngIf="order_index == selected_index">
          <button mat-button (click)="showProductClicked(order_index)" style="background: #dfb59b;">
            Hide Product &nbsp;
            <i class="material-icons" style="font-size: 25px;">
              expand_less
            </i>
          </button>
        </div>
      </div><br>
      <table class="table table-bordered table-hovered" *ngIf="order_index == selected_index">
        <thead>
          <tr>
            <th>S. No</th>
            <th>Product Short Name</th>
            <th>Count</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody *ngFor="let product of order['product_list']; let product_index=index">
          <tr>
            <td>{{product_index + 1}}</td>
            <td>{{product['by_product_name']}}</td>
            <td>{{product['count']}}</td>
            <td>{{product['cost']}}</td>
          </tr>
        </tbody>
      </table>
    </mat-card>
  </span>
</section>
